[
 {
  "id": "chris",
  "name": "Xris",
  "style": "sharp, land-grabber, cool-headed",
  "profile": {
   "riskPreference": 0.25,
   "knockBias": 0.32,
   "takeMiddleBias": 0.23,
   "exploration": 0.13,
   "useInference": true
  },
  "record": {
   "games": 627,
   "wins": 182,
   "avgScore": 296,
   "statesPerGame": 10.46,
   "kings": 165
  }
 },
 {
  "id": "kym",
  "name": "Kym",
  "style": "sharp, land-grabber, steady scorer",
  "profile": {
   "riskPreference": 0.1,
   "knockBias": 0.62,
   "takeMiddleBias": -0.39,
   "exploration": 0.15,
   "useInference": true
  },
  "record": {
   "games": 12,
   "wins": 5,
   "avgScore": 296,
   "statesPerGame": 11.25,
   "kings": 6
  }
 },
 {
  "id": "balin",
  "name": "Balin",
  "style": "sharp, steady scorer",
  "profile": {
   "riskPreference": 0.15,
   "knockBias": 0.17,
   "takeMiddleBias": -0.23,
   "exploration": 0.12,
   "useInference": true
  },
  "record": {
   "games": 224,
   "wins": 69,
   "avgScore": 294,
   "statesPerGame": 10.31,
   "kings": 56
  }
 },
 {
  "id": "rhett",
  "name": "Rhett",
  "style": "sharp, gambler, patient",
  "profile": {
   "riskPreference": -0.15,
   "knockBias": -0.03,
   "takeMiddleBias": 0.01,
   "exploration": 0.27,
   "useInference": true
  },
  "record": {
   "games": 566,
   "wins": 117,
   "avgScore": 286,
   "statesPerGame": 9.97,
   "kings": 61
  }
 },
 {
  "id": "steve",
  "name": "Steve",
  "style": "sharp, cool-headed",
  "profile": {
   "riskPreference": 0.81,
   "knockBias": 0.23,
   "takeMiddleBias": 0.39,
   "exploration": 0.15,
   "useInference": true
  },
  "record": {
   "games": 459,
   "wins": 128,
   "avgScore": 296,
   "statesPerGame": 10.42,
   "kings": 97
  }
 },
 {
  "id": "ken",
  "name": "Ken",
  "style": "sharp, gambler",
  "profile": {
   "riskPreference": -0.72,
   "knockBias": -0.03,
   "takeMiddleBias": -0.46,
   "exploration": 0.13,
   "useInference": true
  },
  "record": {
   "games": 242,
   "wins": 72,
   "avgScore": 290,
   "statesPerGame": 10.1,
   "kings": 52
  }
 },
 {
  "id": "kathee",
  "name": "Kathee",
  "style": "cool-headed, land-grabber",
  "profile": {
   "riskPreference": 0.75,
   "knockBias": 0.63,
   "takeMiddleBias": -0.21,
   "exploration": 0.26,
   "useInference": true
  },
  "record": {
   "games": 83,
   "wins": 18,
   "avgScore": 284,
   "statesPerGame": 10.4,
   "kings": 141
  }
 },
 {
  "id": "dina",
  "name": "Dina",
  "style": "gambler, land-grabber",
  "profile": {
   "riskPreference": -0.76,
   "knockBias": 0.55,
   "takeMiddleBias": -0.03,
   "exploration": 0.27,
   "useInference": true
  },
  "record": {
   "games": 64,
   "wins": 13,
   "avgScore": 285,
   "statesPerGame": 10.38,
   "kings": 18
  }
 },
 {
  "id": "graham",
  "name": "Graham",
  "style": "gambler, loose, big-hand hunter",
  "profile": {
   "riskPreference": -1.13,
   "knockBias": 0.2,
   "takeMiddleBias": 0.3,
   "exploration": 0.38,
   "useInference": false
  },
  "record": {
   "games": 180,
   "wins": 23,
   "avgScore": 281,
   "statesPerGame": 9.97,
   "kings": 2
  }
 },
 {
  "id": "andrew",
  "name": "Andrew",
  "style": "land-grabber, sharp",
  "profile": {
   "riskPreference": 0.11,
   "knockBias": 0.26,
   "takeMiddleBias": 0.07,
   "exploration": 0.26,
   "useInference": true
  },
  "record": {
   "games": 459,
   "wins": 96,
   "avgScore": 286,
   "statesPerGame": 10.16,
   "kings": 76
  }
 },
 {
  "id": "mike",
  "name": "Mike",
  "style": "loose, big-hand hunter",
  "profile": {
   "riskPreference": 0.29,
   "knockBias": -0.16,
   "takeMiddleBias": 0.39,
   "exploration": 0.37,
   "useInference": false
  },
  "record": {
   "games": 168,
   "wins": 23,
   "avgScore": 282,
   "statesPerGame": 9.79,
   "kings": 0
  }
 },
 {
  "id": "casey",
  "name": "Casey",
  "style": "cool-headed, patient, loose",
  "profile": {
   "riskPreference": 0.76,
   "knockBias": -0.45,
   "takeMiddleBias": 0.27,
   "exploration": 0.35,
   "useInference": false
  },
  "record": {
   "games": 27,
   "wins": 3,
   "avgScore": 280,
   "statesPerGame": 9.33,
   "kings": 0
  }
 },
 {
  "id": "brady",
  "name": "Brady",
  "style": "cool-headed, patient",
  "profile": {
   "riskPreference": 0.7,
   "knockBias": -0.41,
   "takeMiddleBias": 0.22,
   "exploration": 0.35,
   "useInference": false
  },
  "record": {
   "games": 103,
   "wins": 15,
   "avgScore": 282,
   "statesPerGame": 9.59,
   "kings": 0
  }
 },
 {
  "id": "vinnie",
  "name": "Vinnie",
  "style": "cool-headed, loose, steady scorer",
  "profile": {
   "riskPreference": 0.55,
   "knockBias": 0.01,
   "takeMiddleBias": -0.26,
   "exploration": 0.37,
   "useInference": false
  },
  "record": {
   "games": 25,
   "wins": 2,
   "avgScore": 268,
   "statesPerGame": 9.48,
   "kings": 0
  }
 },
 {
  "id": "peter",
  "name": "Peter",
  "style": "gambler, patient",
  "profile": {
   "riskPreference": -0.71,
   "knockBias": -0.29,
   "takeMiddleBias": 0.01,
   "exploration": 0.3,
   "useInference": true
  },
  "record": {
   "games": 18,
   "wins": 3,
   "avgScore": 281,
   "statesPerGame": 9.44,
   "kings": 9
  }
 },
 {
  "id": "eve",
  "name": "Eve",
  "style": "gambler, loose, patient",
  "profile": {
   "riskPreference": -0.78,
   "knockBias": -0.43,
   "takeMiddleBias": 0.09,
   "exploration": 0.38,
   "useInference": false
  },
  "record": {
   "games": 96,
   "wins": 12,
   "avgScore": 278,
   "statesPerGame": 9.48,
   "kings": 3
  }
 },
 {
  "id": "susanne",
  "name": "Susanne",
  "style": "loose, gambler",
  "profile": {
   "riskPreference": -0.31,
   "knockBias": -0.17,
   "takeMiddleBias": 0.09,
   "exploration": 0.48,
   "useInference": false
  },
  "record": {
   "games": 172,
   "wins": 10,
   "avgScore": 272,
   "statesPerGame": 9.49,
   "kings": 0
  }
 },
 {
  "id": "rini",
  "name": "Rini",
  "style": "big-hand hunter, land-grabber",
  "profile": {
   "riskPreference": 0.37,
   "knockBias": 0.33,
   "takeMiddleBias": 0.51,
   "exploration": 0.33,
   "useInference": false
  },
  "record": {
   "games": 71,
   "wins": 11,
   "avgScore": 286,
   "statesPerGame": 10.24,
   "kings": 0
  }
 },
 {
  "id": "gioia",
  "name": "Gioia",
  "style": "loose, patient, gambler",
  "profile": {
   "riskPreference": -0.2,
   "knockBias": -0.35,
   "takeMiddleBias": -0.19,
   "exploration": 0.37,
   "useInference": false
  },
  "record": {
   "games": 25,
   "wins": 2,
   "avgScore": 269,
   "statesPerGame": 9.12,
   "kings": 0
  }
 },
 {
  "id": "deb",
  "name": "Deb",
  "style": "patient, loose, big-hand hunter",
  "profile": {
   "riskPreference": 0.06,
   "knockBias": -0.31,
   "takeMiddleBias": 0.11,
   "exploration": 0.33,
   "useInference": false
  },
  "record": {
   "games": 11,
   "wins": 1,
   "avgScore": 276,
   "statesPerGame": 9.09,
   "kings": 0
  }
 },
 {
  "id": "rob",
  "name": "Rob",
  "style": "sharp, land-grabber",
  "profile": {
   "riskPreference": 0.05,
   "knockBias": 0.71,
   "takeMiddleBias": 0.01,
   "exploration": 0.18,
   "useInference": true
  },
  "record": {
   "games": 91,
   "wins": 25,
   "avgScore": 292,
   "statesPerGame": 10.67,
   "kings": 34
  }
 },
 {
  "id": "bungy",
  "name": "Bungy",
  "style": "gambler, loose, steady scorer",
  "profile": {
   "riskPreference": -1.2,
   "knockBias": -0.25,
   "takeMiddleBias": -0.41,
   "exploration": 0.4,
   "useInference": false
  },
  "record": {
   "games": 16,
   "wins": 0,
   "avgScore": 255,
   "statesPerGame": 8.75,
   "kings": 0
  }
 },
 {
  "id": "ryan",
  "name": "Ryan",
  "style": "patient, loose",
  "profile": {
   "riskPreference": -0.01,
   "knockBias": -0.55,
   "takeMiddleBias": -0.08,
   "exploration": 0.36,
   "useInference": false
  },
  "record": {
   "games": 15,
   "wins": 1,
   "avgScore": 269,
   "statesPerGame": 8.67,
   "kings": 0
  }
 },
 {
  "id": "sue",
  "name": "Sue",
  "style": "loose, patient, cool-headed",
  "profile": {
   "riskPreference": 0.12,
   "knockBias": -0.27,
   "takeMiddleBias": -0.03,
   "exploration": 0.4,
   "useInference": false
  },
  "record": {
   "games": 227,
   "wins": 27,
   "avgScore": 276,
   "statesPerGame": 9.56,
   "kings": 0
  }
 },
 {
  "id": "matt",
  "name": "Matt",
  "style": "loose, patient",
  "profile": {
   "riskPreference": -0.09,
   "knockBias": -0.68,
   "takeMiddleBias": -0.37,
   "exploration": 0.41,
   "useInference": false
  },
  "record": {
   "games": 144,
   "wins": 15,
   "avgScore": 272,
   "statesPerGame": 9.15,
   "kings": 8
  }
 },
 {
  "id": "scott",
  "name": "Scott",
  "style": "land-grabber, cool-headed",
  "profile": {
   "riskPreference": 0.26,
   "knockBias": 0.46,
   "takeMiddleBias": -0.07,
   "exploration": 0.3,
   "useInference": false
  },
  "record": {
   "games": 8,
   "wins": 1,
   "avgScore": 274,
   "statesPerGame": 10.63,
   "kings": 0
  }
 },
 {
  "id": "chloe",
  "name": "Chloe",
  "style": "cool-headed, loose",
  "profile": {
   "riskPreference": 0.72,
   "knockBias": -0.07,
   "takeMiddleBias": 0.39,
   "exploration": 0.37,
   "useInference": false
  },
  "record": {
   "games": 10,
   "wins": 0,
   "avgScore": 276,
   "statesPerGame": 9.5,
   "kings": 0
  }
 },
 {
  "id": "mrlim",
  "name": "Mr Lim",
  "style": "cool-headed, sharp",
  "profile": {
   "riskPreference": 1,
   "knockBias": -0.01,
   "takeMiddleBias": -0.26,
   "exploration": 0.15,
   "useInference": true
  },
  "record": {
   "games": 80,
   "wins": 24,
   "avgScore": 292,
   "statesPerGame": 10.15,
   "kings": 0
  }
 },
 {
  "id": "dad",
  "name": "Dad",
  "style": "gambler, loose",
  "profile": {
   "riskPreference": -0.44,
   "knockBias": -0.04,
   "takeMiddleBias": -0.1,
   "exploration": 0.36,
   "useInference": false
  },
  "record": {
   "games": 502,
   "wins": 75,
   "avgScore": 279,
   "statesPerGame": 9.78,
   "kings": 7
  }
 }
]
